export default {
  refundedByInitiator: {
    id: 'sav_platform_refund_by_initiator',
    defaultMessage:
      '{formattedAmount} refunded on {date, date, short} by {initiator}',
  },
  refunded: {
    id: 'sav_platform_refund_by_merchant_for_merchant',
    defaultMessage: '{formattedAmount} refunded on {date, date, short}',
  },
  backmarket: {
    id: 'sav_platform_refund_initiator_backmarket',
    defaultMessage: 'Back Market',
  },
}
